import { mapActions, mapGetters } from "vuex";
import claimsSearch from "@/mixins/claimsSearch.js"

export default {
    mixins: [
        claimsSearch,
    ],
    data: () => {
        return {
            listRoute: "/buckets/bucket4",
            approveRouteEx: "/buckets/bucket4/approve"
        }
    },
    methods: {
        ...mapActions({
            fetchSelectedClaimEx: "fetchSelectedClaimEx",
            clearClaimsList: "clearClaimsList",
            clearSelectedClaim: "clearSelectedClaim",
            setSelectedClaimIndex: "setSelectedClaimIndex",

        }),
        buildSearchValues(payload) {
            if (payload != null) {
                let { claimReference, relatedReference, policyNumber, claimantEmail } = payload

                let criteria = {
                    resellerId: null,
                    claimReference,
                    relatedReference,
                    policyNumber,
                    claimantEmail,
                    incidentDate: null,
                    incidentTypeId: null,
                    fastTrack: null,
                    insuranceLineId: null,
                    portalGroupId: null,
                    claimStatus: null,
                    underwriterId: null
                }
                console.log("-c: ", criteria)
                return criteria
            }
        },
        async handleSearchClickEx(payload) {
            let searchRes = null
            let criteria = null

            if (payload != null) {
                this.searchPayload = payload
                criteria = this.buildSearchValues(payload)
            }

            searchRes = await this.claimsSearchV2Async(criteria, 1)
            console.log("-r: ", searchRes)
            if (searchRes) {
                let { data } = searchRes
                console.log("-d: ", data)
                //this.clearClaimsList();
                if (data) {
                    if (data.length == 1) {
                        let { claimId } = data[0]
                        if (!isNaN(claimId)) {
                            this.clearSelectedClaim()
                            await this.fetchSelectedClaimEx(claimId)
                            this.setSelectedClaimIndex(0)
                            this.$router.push(this.approveRouteEx)
                        }
                    } else {
                        this.$router.push(this.listRoute)
                    }
                }
            }
        },
    }
}